import { SnomedItem } from '../../../../models/Entities/Snomed/SnomedModels';
import { AppState } from '../../../../redux/reducers';
import * as SnomedStore from '../../../../redux/middleware/Snomed.Middleware';

export interface IProps {
    value?: string | null;
    displayText?: string | null;
    layerHostId?: string;
    onSelect: (item: SnomedItem) => void;
    onClear: () => void;
}

interface ConnectedProps {
    isSearching: boolean;
    searchResults: SnomedItem[];
}

interface DispatchProps {
    SearchSnomedSpecialties: typeof SnomedStore.actionCreators.SearchSnomedSpecialties;
    ClearSnomedSearch: typeof SnomedStore.actionCreators.ClearSnomedSearch;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
    isSearching: state.Snomed?.isSearching ?? false,
    searchResults: state.Snomed?.searchResults ?? [],
    ...ownProps
});

export const mapDispatchToProps = {
    ...SnomedStore.actionCreators
};
